// Copyright (c) StrangeBee 2023

import React, { ReactElement, useMemo } from 'react';

interface THSelectorItemProps<T> {
    item: T;
    selected?: boolean;
    onClickHandler?: (item: T) => () => void;
    children: (item: T, value?: boolean, index?: number) => ReactElement;
    index: number;
}

const THSelectorItem = <T,>({
    item,
    selected = false,
    onClickHandler,
    children,
    index,
}: THSelectorItemProps<T>): ReactElement | null => {
    const childDom = useMemo(() => children(item, selected, index), [children, index, item, selected]);
    return (
        <li className="th-selector__item" onClick={onClickHandler?.(item)}>
            {childDom}
        </li>
    );
};

export default THSelectorItem;
